define('components/user-data/main',[
    'components/boilerplate/models/base'
], function (Base) {
    "use strict";

    var userData = $.extend(
        true,

        {
            "landingPage": "/",
            "user": {
                "firstname": "Firstname",
                "lastname": "Lastname",
                "role": "teacher"
            }
        },

        window.eyf && window.eyf.user_data
    );

    userData.user.firstname = userData.user.firstname || '';
    userData.user.lastname = userData.user.lastname || '';
    userData.user.lastInitial = userData.user.lastname.substr(0, 1) || '';

    $.extend(userData.user, {
        "isStudent": userData.user.role === "student",
        "isTeacher": userData.user.role === "teacher",
        "isVolunteer": userData.user.role === "volunteer",

        // This property is used throughout the code
        // whenever the user's name is to be displayed.
        // The actual nature of the display name is dictated by
        // the client (PwC) and can change anytime.
        // Having the value of this property set here
        // (in one place) helps reduce the head ache associated
        // with business requirements.
        "displayName": userData.user.firstname
    });

    return userData;
});

